module.exports = __webpack_public_path__ + "lib/1It5ajFp.svg";